import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { events } from "../../api/endpoints";
import Api_Instance from "../../api/Api_Instance";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

function Upcomingevents() {
  const api = Api_Instance.unAuth();
  const [data, setData] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);

  const getApi = async () => {
    try {
      const res = await api("GET", events.POST_UPCOMING);
      setData(res?.data?.data);
    } catch { }
  };

  useEffect(() => {
    getApi();
  }, []);

  const handleViewMore = () => {
    setVisibleCount((prevCount) => prevCount + 4);
  };

  return (
    <div className=" xl:px-0 lg:px-0 md:px-5 px-4" id='event'>
      <div className="mb-3">
        <h1 className="text-start font-bold 2xl:text-[32px] xl:text-[32px] lg:text-[32px] md:text-4xl text-2xl xl:mb-5 lg:mb-5 md:mb-5 mb-3 ">
          Upcoming <span className="text-secondaryColor">Events</span>
        </h1>
        <hr />
      </div>
      <div className="grid grid-cols-1 bg-[#f9f8f8] p-4 rounded sm:gap-5 mx-auto md:gap-2-important lg:gap-0-important xl:gap-0-important gap-4">
       
        <Swiper
          spaceBetween={30}
          centeredSlides={true}
          autoplay={{
            delay: 2000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
          }}
          pagination={{
            dynamicBullets: true,
            clickable: true,
          }}
          loop={true}
          navigation={false}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper2 w-[100%] pb-5"
        >
          { data?.map((item, index) => (
            
            <SwiperSlide>
              <div key={index} className="p-0">
                <div className="relative overflow-hidden bg-cover flex justify-center items-center">
                  <img
                    className="w-full h-32 border border-gray-200 rounded-md hover:scale-110 transition-all duration-300 ease-in-out"
                    src={`${item?.image}`}
                    alt="Event"
                  />
                </div>
                <div className="mt-1">
                  <h3 className="text-xl font-semibold text-gray-800 w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">
                    {item?.Event_name}
                  </h3>
                  <div className="mt-2 grid grid-cols-1 gap-x-5">
                    <div class="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p class="flex-[0_0_50%] whitespace-nowrap">City</p>
                      <p class="font-bold text-start 2xl:flex-[0_0_50%]  flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.city}</p></div>
                    <div class="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p class="flex-[0_0_50%] whitespace-nowrap">Venue</p>
                      <p class="font-bold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.venue}</p>
                    </div>
                    <div class="flex justify-between text-sm text-gray-600 mb-[10px]">
                      <p class="flex-[0_0_50%] whitespace-nowrap">Date</p>
                      <p class="font-bold text-start 2xl:flex-[0_0_50%] flex-[0_0_35%] w-[200px] overflow-hidden overflow-ellipsis whitespace-nowrap">{item?.date}</p>
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          ))}

        </Swiper>
      </div>
     
    </div>
  );
}

export default Upcomingevents;
